<template>
  <div>
    <vs-row>
      <vs-col vs-w="6">
        <h3 style="margin-bottom: 20px">Pago pendiente</h3>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col
        style="margin-bottom: 10px"
        type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <h4 class="mb-2">Revisa tu email</h4>
        <p>
          <b>Te hemos enviado un email con instrucciones</b> para realizar el
          pago de la actividad.
        </p>
        <!-- <p>También recibirás un <b>sms</b> con un enlace para completar el pago.</p> -->
        <!-- <p>
          Puedes usar cualquiera de esos dos sistemas para realizar el pago.
        </p> -->
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import JQuery from 'jquery'
//let $ = JQuery

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {},
  methods: {},
  components: {},
};
</script>
